<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { getShadow } from '$lib/global/helper/shadow';

    import ImageSliderView from './ImageSlider.View.svelte';

    import type { ImageSliderContent } from '$lib/types/Components/ImageSlider/ImageSliderContent';
    import type { Language } from '$lib/types/Language';
    import type { BrandShadow, Theme, TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let content: ImageSliderContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let layout = DEFAULT_LAYOUT;
    export let theme: Theme | undefined = undefined;
    export let language: Language = 'en';

    const shadowClass =
        content.framed && !layout.isInColumn && theme?.shadow
            ? getShadow('blockFrame', theme.shadow as BrandShadow)
            : undefined;

    const inactivePillColor = theme?.surface;
    const activePillColor = inactivePillColor ? theme?.buttonBackgroundColor : undefined;
</script>

<ImageSliderView
    {id}
    images={content.images}
    framed={content.framed}
    size={content.size}
    bgColor={content.box.backgroundColor}
    {shadowClass}
    {activePillColor}
    {inactivePillColor}
    {transitionDelay}
    {transitionEffect}
    {layout}
    {language}
/>
